import { useEffect, useState } from 'react';

export default function useClerkLoadTimeout(isLoaded, timeoutMs = 5000) {
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (isLoaded) {
      setTimedOut(false);
      return undefined;
    }

    const timeoutId = window.setTimeout(() => {
      setTimedOut(true);
    }, timeoutMs);

    return () => {
      window.clearTimeout(timeoutId);
    };
  }, [isLoaded, timeoutMs]);

  return timedOut;
}
